<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="disclaimer-page">
    <mat-card class="disclaimer-card">
        <mat-card-header>
            <mat-card-title><h3>Welcome to {{ siteName }}</h3></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="site-description" [innerHTML]="siteDescription"></div>
            <div fxLayout="column" fxLayoutAlign="space-between stretch">
                <button matButton="tonal" (click)="showLogin()">Continue</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
